import axios from 'axios';
//import i18n from '@/locales/i18n';
//import { getWebPagesId } from '@/utils/webPage';    
const API_URL = 'https://prokuroriaapi.cmdsoftwares.com/api/v1/';

class KontaktService {

   
  async getKontaktet() {
    // const webPage = getWebPagesId();
    return await axios
     .get(`${API_URL}contact`)
    .then((response) =>response.data);

}







async getKontaktetById(id) {
//  const webPage = getWebPagesId();
  return await axios
    .get(`${API_URL}contact/${id}`)
    .then((response) => response.data);
}




}

export default new KontaktService();

